import { HelpCircleIcon } from '@jotpsych/ui/icons';
import { IconButton, Tooltip } from '@mui/material';

import type { GuideLinkShape } from '../types';

import { GuideTextLink } from './GuideLinkControl.styles';

type Props = {
  shape: GuideLinkShape;
  /** Visible text for text shapes; the accessible name for the section control. */
  label: string;
  /** Section control only; touch shows no tooltip and Escape dismisses it. */
  tooltip?: string;
  /** Section control only: the tooltip opened by hover or keyboard focus, never by touch. */
  onReveal?: () => void;
  onActivate: () => void;
};

export function GuideLinkControl({ shape, label, tooltip, onReveal, onActivate }: Props) {
  if (shape === 'section-control')
    return (
      <Tooltip title={tooltip ?? label} disableTouchListener onOpen={onReveal}>
        <IconButton size="small" aria-label={label} onClick={onActivate}>
          <HelpCircleIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    );
  return (
    <GuideTextLink
      component="button"
      type="button"
      variant="inherit"
      underline="hover"
      data-shape={shape}
      onClick={onActivate}
    >
      {label}
    </GuideTextLink>
  );
}
